import React from 'react';
interface SkeletonProps {
  className?: string;
  variant?: 'text' | 'circular' | 'rectangular' | 'rounded';
  width?: string | number;
  height?: string | number;
  animation?: 'pulse' | 'wave' | 'none';
}
export function Skeleton({
  className = '',
  variant = 'text',
  width,
  height,
  animation = 'pulse'
}: SkeletonProps) {
  const baseClasses = 'bg-gray-200 dark:bg-gray-700';
  const variantClasses = {
    text: 'w-full h-4 rounded',
    circular: 'rounded-full',
    rectangular: '',
    rounded: 'rounded-lg'
  };
  const animationClasses = {
    pulse: 'animate-pulse',
    wave: 'skeleton-wave',
    none: ''
  };
  const style: React.CSSProperties = {
    width: width !== undefined ? typeof width === 'number' ? `${width}px` : width : undefined,
    height: height !== undefined ? typeof height === 'number' ? `${height}px` : height : undefined
  };
  return <div className={`${baseClasses} ${variantClasses[variant]} ${animationClasses[animation]} ${className}`} style={style} data-id="element-1523" />;
}
interface SkeletonTextProps {
  lines?: number;
  spacing?: 'tight' | 'normal' | 'loose';
  lastLineWidth?: string | number;
  className?: string;
}
export function SkeletonText({
  lines = 3,
  spacing = 'normal',
  lastLineWidth = '70%',
  className = ''
}: SkeletonTextProps) {
  const spacingClasses = {
    tight: 'space-y-1',
    normal: 'space-y-2',
    loose: 'space-y-4'
  };
  return <div className={`${spacingClasses[spacing]} ${className}`} data-id="element-1524">
      {Array.from({
      length: lines
    }).map((_, i) => <Skeleton key={i} variant="text" width={i === lines - 1 ? lastLineWidth : '100%'} data-id="element-1525" />)}
    </div>;
}
export function SkeletonCard() {
  return <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6" data-id="element-1526">
      <div className="flex items-center gap-4 mb-4" data-id="element-1527">
        <Skeleton variant="circular" width={48} height={48} data-id="element-1528" />
        <div className="space-y-2 flex-1" data-id="element-1529">
          <Skeleton variant="text" width="70%" data-id="element-1530" />
          <Skeleton variant="text" width="40%" data-id="element-1531" />
        </div>
      </div>
      <SkeletonText lines={3} data-id="element-1532" />
      <div className="mt-4 flex justify-end" data-id="element-1533">
        <Skeleton variant="rounded" width={100} height={36} data-id="element-1534" />
      </div>
    </div>;
}